export const INSIGHTS_BILL_ANALYSIS_ACTIONS = {
    CHANGE_USAGE_BILL_ANALYSIS_DATA: "CHANGE_USAGE_BILL_ANALYSIS_DATA",
    ERROR_USAGE_BILL_ANALYSIS_DATA: 'ERROR_USAGE_BILL_ANALYSIS_DATA',
    FETCH_USAGE_BILL_ANALYSIS_DATA: 'FETCH_USAGE_BILL_ANALYSIS_DATA'
}

export function changeBillAnalysisData(payload) {
    return {
        type: INSIGHTS_BILL_ANALYSIS_ACTIONS.CHANGE_USAGE_BILL_ANALYSIS_DATA,
        payload: payload
    }
}